import React, { useEffect, useContext } from 'react';

import { AuthContext, } from '../../contexts/auth'

import { useNavigate } from 'react-router-dom'

import {
  Container,
} from './style';

import { api, Refresh, NameSchool, RefreshDepEdu, EducationDepartamentName } from '../../Api'
import { loadSchoolAssessmentInfo } from '../../utils/sessionSchool'

import LoadingSpinner from '../../components/Loading'

const Preload = () => {

  const navigate = useNavigate()
  const { loginEmployee } = useContext(AuthContext)
  const { loginEmployeeEducationDepartment } = useContext(AuthContext)

  useEffect(() => {
    (async () => {
      const id = localStorage.getItem("Id_employee");
      const posi = localStorage.getItem("positionAtEducationDepartment");
      const token = localStorage.getItem("token");
      const lastLogin = localStorage.getItem("lastLogin");

      // ✅ Identificador do responsável (pais)
      const responsibleId = localStorage.getItem("Id_responsible");

      console.log(">>> ID:", id);
      console.log(">>> POSIÇÃO:", posi);
      console.log(">>> TOKEN:", token);
      console.log(">>> LAST LOGIN:", lastLogin);
      console.log(">>> RESPONSÁVEL:", responsibleId);

      const now = Date.now();
      const expirationTime = 24 * 60 * 60 * 1000;

      // 👉 Caso o último usuário seja um responsável (pai/mãe).
      // O responsável não possui preload/Refresh próprio, então
      // apenas verificamos o token e mandamos para o login dos pais.
      if (responsibleId) {
        if (!token || !lastLogin || now - lastLogin > expirationTime) {
          localStorage.clear();
          sessionStorage.clear();
        }
        navigate('/signin/responsible'); // Login dos pais/responsável
        return;
      }

      if (!token || !lastLogin || now - lastLogin > expirationTime) {
        localStorage.clear();
        sessionStorage.clear();
        if (posi) {
          navigate('/signin/employee-education-department'); // Login da SEMEDE
        } else {
          navigate('/signin/employee'); // Login da escola
        }
        return;
      }

      try {
        // ✅ Verifica se é funcionário da SEMEDE
        if (posi) {
          const response = await RefreshDepEdu(JSON.parse(id)); // Outra função para SEMEDE
          if (response && response.data) {
            const data = response.data;
            localStorage.setItem("lastLogin", now);

            // token no header ANTES de qualquer chamada protegida
            api.defaults.headers.Authorization = `Bearer ${data.token}`;

            // nome do departamento protegido: se falhar, não derruba o preload
            let nomeDepartamento = ''
            try {
              const educationDepartment = await EducationDepartamentName(data.idEducationDepartment)
              nomeDepartamento = educationDepartment?.data?.data ?? ''
            } catch (err) {
              console.error('Falha ao buscar nome do departamento:', err)
            }

            //const loggedEmployee = data.CPF
            sessionStorage.setItem("idDepartment", data.idEducationDepartment);
            sessionStorage.setItem("name-department", nomeDepartamento)
            localStorage.setItem("Id_employee", JSON.stringify(data.id))
            sessionStorage.setItem("name", data.name);
            localStorage.setItem("name", data.name)
            sessionStorage.setItem("cpf", data.CPF);
            localStorage.setItem("type", data.type)
            sessionStorage.setItem("token", data.token);
            localStorage.setItem("positionAtEducationDepartment", data.positionAtEducationDepartment);
            localStorage.setItem("token", data.token);
            sessionStorage.setItem("token", data.token)

            loginEmployeeEducationDepartment(data.CPF)

            // Redireciona para painel da SEMEDE
            //navigate('/home/education-department');
            return;
          } else {
            navigate('/signin/employee-education-department');
            return;
          }
        }

        // 👉 Caso seja funcionário da escola
        const response = await Refresh(JSON.parse(id));
        if (response && response.data) {
          localStorage.setItem("lastLogin", now);

          const data = response.data;
          const Schools = data.schools;

          if (Schools) {
            const userCPF = data.schools.map(res => res.cpf);

            sessionStorage.setItem("schools", JSON.stringify(Schools))
            navigate('/school/selection', { state: { schools: Schools, cpf: userCPF } });
            return;
          }

          // ── Validação dos campos essenciais antes de gravar ──────────────
          // Se o Refresh vier incompleto, limpa e volta ao login em vez de
          // gravar dado parcial que quebraria o sistema mais adiante.
          if (!data.token || !data.id || !data.type || !data.id_school) {
            console.error('Refresh incompleto. Campos ausentes:', {
              token: data.token, id: data.id, type: data.type, id_school: data.id_school
            })
            localStorage.clear();
            sessionStorage.clear();
            navigate('/signin/employee');
            return;
          }

          // ── token no header ANTES das chamadas protegidas ────────────────
          // (nome-da-escola e regime exigem token; sem isto retornam 401)
          api.defaults.headers.Authorization = `Bearer ${data.token}`;

          // ── Nome da escola protegido: se falhar, o preload segue ─────────
          let nomeEscola = ''
          try {
            const nameSchool = await NameSchool(data.id_school);
            nomeEscola = nameSchool?.data?.data ?? ''
          } catch (err) {
            console.error('Falha ao buscar nome da escola:', err)
          }

          // ── Busca e grava assessmentFormat + assessmentRegime ────────────
          // Helper centralizado. Regrava a cada preload para manter o storage
          // atualizado (token já está no header logo acima).
          await loadSchoolAssessmentInfo(data.id_school)

          // ── Grava tudo de uma vez (sem await no meio) ────────────────────
          sessionStorage.setItem("School", nomeEscola);
          localStorage.setItem("Id_employee", JSON.stringify(data.id));
          sessionStorage.setItem("cpf", data.CPF);
          sessionStorage.setItem("name", data.name);
          localStorage.setItem("name", data.name);
          localStorage.setItem("type", data.type);
          localStorage.setItem("position_at_school", data.position_at_school);
          sessionStorage.setItem("id-school", JSON.stringify(data.id_school));
          sessionStorage.setItem("id_matter", data.id_matter);
          sessionStorage.setItem("id_class", data.id_class);
          sessionStorage.setItem("id_reporter_cardid_class", data.id_reporter_card);
          localStorage.setItem("token", data.token);
          sessionStorage.setItem("token", data.token);
          // (Authorization já foi setado acima)

          loginEmployee(data.CPF);
        } else {
          navigate('/signin/employee');
        }
      } catch (error) {
        localStorage.clear();
        sessionStorage.clear();
        navigate('/signin/employee');
      }
    })();
  }, [navigate, loginEmployee, loginEmployeeEducationDepartment]);

  return (
    <Container>
      <LoadingSpinner />
    </Container>
  )
}

export default Preload